// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".util__flex.storyblok-grid{display:flex;width:100%;flex-wrap:wrap;justify-content:space-around}.util__flex.storyblok-grid>div{flex:1;display:flex;justify-content:center;align-items:center}@media(max-width:960px){.util__flex.storyblok-grid .storyblok-column{text-align:justify;width:100%!important}}", ""]);
// Exports
module.exports = exports;
